<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">회원관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">일반회원</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="일반회원">일반회원</router-link></li>
            <li><router-link to="/businessmembership" title="사업자회원">사업자회원</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">일반회원 상세정보</h3>
        <article>
          <div class="table horizontal-table">
            <table>
              <caption>
                일반회원 상세정보 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 100px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">아이디</th>
                  <td>{{ employeeInfo.empNo }}</td>
                </tr>
                <tr>
                  <th scope="row">이름</th>
                  <td>{{ employeeInfo.empNm }}</td>
                </tr>
                <tr>
                  <th scope="row">연락처</th>
                  <td>{{ employeeInfo.empMobile }}</td>
                </tr>
                <tr>
                  <th scope="row">차량번호</th>
                  <td>{{ employeeInfo.empCarNo }}</td>
                </tr>
                <tr>
                  <th scope="row">차량소유주명</th>
                  <td>{{ employeeInfo.carOwnerNm }}</td>
                </tr>
                <tr>
                  <th scope="row">차종</th>
                  <td>{{ employeeInfo.carKind }}</td>
                </tr>
                <tr>
                  <th scope="row">주소</th>
                  <td>{{ employeeInfo.addr }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article class="btnArea">
          <button type="button" class="btn border" @click="pwLockInit">비밀번호 잠금 해제</button>
          <button type="button" class="btn border" @click="listBtn">목록</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';

export default {
  data() {
    return {
      empId: '',
      employeeInfo: {},
    };
  },

  mounted() {
    const empId = this.$route.query.id;
    if (!empId) {
      alert('잘못된 접근입니다.');
      this.$router.push('/generalmembership');
    }
    this.empId = empId;
    this.findMember();
  },

  methods: {
    async findMember() {
      const apiParams = new FormData();
      apiParams.append('empEsntlId', this.empId);
      const res = await axios('post', '/api/member/view.json', apiParams);
      this.employeeInfo = res.data.resultVo;
    },

    async pwLockInit() {
      const apiParams = new FormData();
      apiParams.append('empEsntlId', this.empId);
      await axios('post', '/api/member/pw-lock-init', apiParams);
      alert('적용되었습니다.');
    },

    listBtn() {
      this.$router.push('/generalmembership');
    },
  },

  computed: {},
};
</script>
